import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import eventManage from './eventManage';
import requestManage from './requestManage';
import taskManage from './taskManage';
import system from './system';
import knowledge from './knowledgeManage';
import report from './report';
import relevant from './relevant';
import asset from './asset';
import projectManage from './projectManage';
import inspectManage from './inspectManage';
import supplierManage from './supplierManage';
import contractManage from './contractManage';
import slaManage from './slaManage';
import requetConfig from './requetConfig';
import home from './home';
import customerHome from './customerHome';
import workOrder from './workOrder';
import serviceDesk from './serviceDesk';

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

const Login = () => import('@/components/pages/Login');
const Platform = () => import(/* webpackChunkName: "base" */'@/components/pages/platform/Platform');
const AssetPlatform = () => import(/* webpackChunkName: "base" */'@/components/pages/platform/asset/Platform');
const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const Redirect = () => import(/* webpackChunkName: "base" */'@/components/common/Redirect');
const KnowledgeDetail = () => import(/* webpackChunkName: "knowledgeManage" */'@/components/pages/knowledgeManage/KnowledgeDetail');
const NotFound = () => import(/* webpackChunkName: "base" */'@/components/pages/NotFound');
const Profile = () => import(/* webpackChunkName: "base" */'@/components/pages/user/Profile');

export const basicRouters = [
	{
		path: '/login',
		name: 'login',
		component: Login
  },
  {
		path: '/report/platform',
		name: 'Platform',
		component: Platform
  },
  {
		path: '/report/asset-platform',
		name: 'AssetPlatform',
		component: AssetPlatform
  },
  {
    path: '/knowledge-manage/:id/share',
    name: 'knowledgeShare',
    props: true,
    meta: {
      hidden: true
    },
    component: KnowledgeDetail,
  },
  {
		path: '/personal',
    name: 'personal',
    component: Layout,
    children: [
      {
        path: 'profile',
        name: 'profile',
        meta: {
          title: '个人信息',
          componentName: 'Profile',
          breadcrumb: [
            {
              name: '个人信息',
              path: '/personal/profile'
            }
          ]
        },
        component: Profile
      }
    ]
	}
]

export const routes = [
  {
    path: '/redirect',
    name: 'redirect',
    component: Layout,
    children: [
      {
        path: '/redirect/:path*',
        component: Redirect
      }
    ]
  },
  {
    path: '/',
    redirect: '/variable-home'
  },
  ...home,
  ...serviceDesk,
  ...workOrder,
  // ...eventManage,
  // ...requestManage,
  // ...taskManage,
  ...knowledge,
  ...projectManage,
  ...asset,
  ...inspectManage,
  ...contractManage,
  // ...slaManage,
  // ...requetConfig,
  ...supplierManage,
  ...report,
  ...system,
  ...relevant,
  ...customerHome,
  {
    path: '*',
    component: Layout,
    meta: {},
    children: [
      {
        path: '',
        meta: {
          roles: [],
          title: '暂无权限',
          hidden: true
        },
        component: NotFound
      }
    ]
}
]

const createRouter = () =>
  new VueRouter({
    mode: 'history',
    base: '/',
    routes: basicRouters
  })

const router = createRouter()

router.resetRouter = params => {
  router.matcher = createRouter().matcher;
  router.addRoutes(params);
};

router.beforeEach((to, from, next) => {
  next();
  if (to.meta.title) {
    let title = to.meta.title || '';
    let secondParentRoute = {};
    if (to.matched.length > 2) {
      secondParentRoute = to.matched[to.matched.length - 2] || {};
      title = (secondParentRoute.meta || {}).title || '';
    }
    store.dispatch('workPageRoute', {
      to: {
        name: to.name ? to.name : '',
        title: title,
        path: to.fullPath,
        routePath: to.path,
        componentName: to.meta.componentName || '',
        secondParent: secondParentRoute.path,
      },
      from: {
        name: from.name ? from.name : '',
        title: (from.meta && from.meta.title) ? from.meta.title : '',
        path: from.fullPath,
        routePath: to.path,
        componentName: to.meta.componentName || ''
      }
    });
  }
  return;
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js